export enum DepositStatus {
  RECEIVED = 'received',
  REJECTED = 'rejected',
  WON = 'won',
}
